import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.1_@types+node@22.15.21_eslint@9.15.0_ioredis@5.4.1_rollup@4.40.1_typescript@5.6.3_v_aimeh3knaoyzr6hujmlqqqe43e/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}